import React from 'react';
import { Box } from '../../Box/Box';
import { Flex } from '../../Flex/Flex';
import { Image } from '../../Image/Image';
import { Text } from '../../Text/Text';
/**
 * @public
 */
export const Hero = ({
  name,
  children,
  img
}) => React.createElement(Flex, {
  alignItems: 'center',
  flexDirection: 'row',
  bg: 'primary.light',
  borderRadius: 24,
  p: 4,
  style: {
    gap: 32
  }
}, React.createElement(Flex, {
  flexDirection: 'column',
  style: {
    flex: '1 100%',
    gap: 8
  }
}, React.createElement(Text, {
  textStyle: 'title3',
  color: 'text.heading'
}, name), React.createElement(Text, null, children)), React.createElement(Box, {
  bg: 'primary.tint',
  borderRadius: 'xl',
  style: {
    flex: '1 100%'
  }
}, React.createElement(Image, {
  src: img
})));